
module.exports = function(bootstrap) {
    bootstrap.filter('clientPagination', function() {
        return function(list, options) {
            if(!list) {
                list = [];
            }

            var start = (options.page - 1) * options.itemsPerPage;
            var end = ~Number(options.itemsPerPage) ? start + Number(options.itemsPerPage) : list.length;
            return list.slice(start, end);
        };
    });
    bootstrap.directive('clientPaginationControls', ["modal", "navigation", "brand", "services", "session", "$state", "$cookies", "coremetrics", "teamsite", "$document", "$timeout", function(modal, navigation, brand, services, session, $state, $cookies, coremetrics, teamsite, $document, $timeout) {
        return {
            scope: {
                length: '=',
                itemsPerPage: '=',
                page: '='
            },
            template:   '<nav data-ng-show="length > 10" class="repeat-pagination">'+
                '<button class="prev-button" data-ng-click="prev()" data-ng-if="page != 1">&lt; Prev</button>'+
                '<ul class="hmhs-margin-tweek">'+
                '<li><button data-ng-if="page > 3" data-ng-click="goTo(1,true)">1</button></li> '+
                // '<li><span data-ng-if="page > 2"><span data-ng-if="page > 3">...</span><button data-ng-click="goTo(page - 2)" data-ng-if="page <= 3">{{page - 2}}</button></span></li> '+
                '<li><span data-ng-if="page > 2"><span data-ng-if="page > 4">...</span><button data-ng-click="goTo(page - 2,true)" data-ng-if="page <= 4">{{page - 2}}</button></span></li> '+
                '<li><button data-ng-if="page > 1" data-ng-click="goTo(page - 1,true)">{{page - 1}}</button></li> '+
                '<li class="current-page"><span>{{page}}</span></li> '+
                '<li><button data-ng-if="page < lastPage" data-ng-click="goTo(page + 1,true)">{{page + 1}}</button></li> '+
                // '<li><span data-ng-if="page < (lastPage - 1)"><span data-ng-if="page < (lastPage - 2)">...</span><button data-ng-click="goTo(page + 2)" data-ng-if="page >= (lastPage - 2)">{{page + 2}}</button></span></li>'+
                '<li><span data-ng-if="page < (lastPage - 1)"><span data-ng-if="page < (lastPage - 3)">...</span><button data-ng-click="goTo(page + 2,true)" data-ng-if="page >= (lastPage - 3)">{{page + 2}}</button></span></li>'+
                '<li><button data-ng-if="page < (lastPage - 2)" data-ng-click="goTo(lastPage,true)">{{lastPage}}</button></li>'+
                '</ul>'+
                '<button class="next-button" data-ng-click="next()" data-ng-if="page != lastPage">Next &gt;</button>'+
                '</nav>',

            link: function(scope, element, attrs) {
                scope.page = scope.page || 1;
                scope.$watch('length', function(length) {
                    if (length) {
                        scope.lastPage = Math.ceil(length / scope.itemsPerPage);
                        if(scope.lastPage < scope.page){
                            scope.goTo(1);
                        }
                    }
                });
                var innerHTML;
                scope.options = [{
                    label: "10",
                    value: "10"
                },{
                    label: "20",
                    value: "20"
                },{
                    label: "50",
                    value: "50"
                },{
                    label: "View All",
                    value: "-1"
                }];
                scope.changePer = function() {
                    scope.lastPage = Math.ceil(scope.length / scope.itemsPerPage);
                    scope.goTo(1);
                };
                scope.prev = function() {
                    scope.$emit('prevClick');
                    if (scope.page > 1) {
                        scope.goTo(scope.page - 1,false);
                    }
                };
                scope.next = function() {
                    scope.$emit('nextClick');
                    if (scope.page < scope.lastPage) {
                        scope.goTo(scope.page + 1,false);
                    }
                };
                scope.goTo = function(page,skipEmit) {
                    // var old = element[0].getBoundingClientRect().top;
                    scope.page = page;
                    if(skipEmit){
                        scope.$emit('goToPageClick');
                    }
                    //$timeout(function() {
                    //    // document.body.scrollTop = document.body.scrollTop - old + element[0].getBoundingClientRect().top;
                    //    $('html, body').animate({scrollTop: 0}, 1); // Cross broswer friendly way to control scroll top.  Duration of 1ms because we don't want flicker.
                    //}, 10);
                };
            }
        };
    }])
}